export enum LocalStorageKeysEnum {
	USER = 'user',
	ACTIVE_PRODUCT = 'active_product',
	SUCCESS_PAYMENT_PAGE_VISIBILITY = 'success_payment_page_visibility',
	PAYMENT_PROCESSING = 'payment_processing',
}

export type LocalStorageKeys = keyof typeof LocalStorageKeysEnum
